// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes slideOutLeft {
  to {
    transform: translateX(-100%);
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.animatable.ng-enter {
  animation: slideInRight 1s both ease-in;
  z-index: 8888;
}
.animatable.ng-leave {
  animation: slideOutLeft 1s both ease-in;
  z-index: 9999;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/animations.css"],"names":[],"mappings":"AAAA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,uCAAuC;EACvC,aAAa;AACf;AACA;EACE,uCAAuC;EACvC,aAAa;AACf","sourcesContent":["@keyframes slideOutLeft {\n  to {\n    transform: translateX(-100%);\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.animatable.ng-enter {\n  animation: slideInRight 1s both ease-in;\n  z-index: 8888;\n}\n.animatable.ng-leave {\n  animation: slideOutLeft 1s both ease-in;\n  z-index: 9999;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
